import { CardLayout, type CardLayoutInput } from './cardLayout';

const inputs: CardLayoutInput[] = [
    { key: 'card-slider-default', label: 'Card slider - Default', referenceId: [] },
    { key: 'card-slider-video-default', label: 'Card slider - Video Default', referenceId: [] },
    { key: 'card-wall-thumb-2-3-default', label: 'Card wall - Portrait cover default', referenceId: ['mk_card_type_simpleportrait'] },
    { key: 'card-wall-thumb-2-3-logo', label: 'Card wall - Portrait cover with logo', referenceId: ['mk_card_type_logoportrait'] },
    { key: 'card-wall-thumb-1-1-default', label: 'Card wall - Squared cover default', referenceId: ['mk_card_type_simpleportraits'] },
    { key: 'card-wall-thumb-1-1-logo', label: 'Card wall - Squared cover with logo', referenceId: ['mk_card_type_logosquare'] },
    { key: 'card-wall-thumb-2-3-default-video-background', label: 'Card wall - Portrait video cover default', referenceId: ['mk_card_type_simpleportrait_v'] },
    { key: 'card-wall-thumb-2-3-logo-video-background', label: 'Card wall - Portrait video cover with logo', referenceId: ['mk_card_type_logoportrait_v'] },
    { key: 'card-wall-thumb-1-1-default-video-background', label: 'Card wall - Squared video cover default', referenceId: ['mk_card_type_simpleportraits_v'] },
    { key: 'card-wall-thumb-1-1-logo-video-background', label: 'Card wall - Squared video cover with logo', referenceId: ['mk_card_type_logosquare_v'] },
    { key: 'card-wall-abstract-default', label: 'Card wall - Abstract default', referenceId: ['mk_card_type_abstracttextonl'] },
    { key: 'card-wall-abstract-cover', label: 'Card wall - Abstract with cover', referenceId: ['mk_card_type_abstractwiththu'] },
    { key: 'card-wall-business-impacts', label: 'Card wall - Business Impacts', referenceId: ['mk_card_type_businessimpacts'] },
    { key: 'card-wall-event-default', label: 'Card wall - Event default', referenceId: ['mk_card_type_event'] },
    { key: 'card-wall-event-careers', label: 'Card wall - Event Careers', referenceId: ['mk_card_type_careersevent'] },
    { key: 'card-award-default', label: 'Card award - Default', referenceId: [] },
    { key: 'card-award-combined', label: 'Card award - Combined', referenceId: [] },
    { key: 'card-info-slider-1-1-default', label: 'Card info slider - Square', referenceId: [] },
    { key: 'card-info-slider-1-1-light', label: 'Card info slider - Square light', referenceId: [] },
    { key: 'card-info-slider-2-3-default', label: 'Card info slider - Portrait', referenceId: [] },
    { key: 'card-info-slider-1-1-icon', label: 'Card info slider - Square with icon', referenceId: [] },
    { key: 'card-info-slider-1-1-icon-small', label: 'Card info slider - Square, small with icon', referenceId: [] },
    { key: 'card-info-slider-1-1-icon-dark', label: 'Card info slider - Square with icon dark', referenceId: [] },
    { key: 'card-info-slider-1-1-icon-dark-small', label: 'Card info slider - Square, small with icon dark', referenceId: [] },
    { key: 'card-horizontal-editorial', label: 'Card horizontal - Editorial', referenceId: [] },
    { key: 'card-hero-default', label: 'Card hero - Default', referenceId: [] },
    { key: 'card-office-default', label: 'Card Office - Default', referenceId: ['mk_card_type_office'] },
    { key: 'card-website-default', label: 'Card Website - Default', referenceId: ['mk_card_type_website'] },
    { key: 'card-info-banner-default', label: 'Info Banner', referenceId: [] },
    { key: 'card-serp-default', label: 'SERP - Result card', referenceId: [] },
    { key: 'card-wall-hover-1-1-default', label: 'Card wall - Hover squared cover default', referenceId: ['mk_card_type_prodsquaredef'] },
    { key: 'card-wall-hover-2-3-default', label: 'Card wall - Hover portrait cover default', referenceId: ['mk_card_type_prodportraitdef'] },
    { key: 'card-wall-product-default', label: 'Card wall - Product & accelerator', referenceId: ['mk_card_type_prodaccdefault'] },
    { key: 'card-wall-release-default', label: 'Card wall - Fresh release', referenceId: ['mk_card_type_releasedefault'] },
];

class CardLayoutsFactory {

    private layouts: CardLayout[];

    private constructor() {
        this.layouts = inputs.map((i: CardLayoutInput) => new CardLayout(i));
    }

    public static build(): CardLayoutsFactory {
        return new CardLayoutsFactory();
    }

    public get(key?: string): CardLayout[] {
        if (!key) {
            return JSON.parse(JSON.stringify(this.layouts));
        }
        return JSON.parse(JSON.stringify(this.layouts.filter((i: CardLayout) => i.key === key)));
    }

    public getDefault(): CardLayout {
        return JSON.parse(JSON.stringify(this.layouts[0]));
    }

    public getDefaultKey(): string {
        return this.layouts[0].key;
    }

    public getKeyByReferenceId(id: string): string {
        if (!id) {
            return undefined;
        }
        const found: CardLayout = this.layouts.find((i: CardLayout) => i.referenceId.indexOf(id) !== -1 );
        return found ? found.key : undefined;
    }
}

const layouts = CardLayoutsFactory.build();

export { layouts as CardLayouts };